import { ModalCustom } from "components/ModalCustom";
import { Body, IconeContainer, InfoContainer, TextContainer } from "./style";
import { FaExclamation } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: () => void;
}

export function ModalExcluirParceiro({ show, handleClose, onConfirm }: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Excluir parceiro"
      centered
      footer
      footerConfirmButton
      onConfirm={onConfirm}
      size={"lg"}
    >
      <Body>
        <InfoContainer>
          <IconeContainer>
            <FaExclamation />
          </IconeContainer>
          <TextContainer>
            Após confirmar esta ação e clicar em "Salvar", o parceiro será
            excluído. Deseja confirmar a exclusão deste parceiro?
          </TextContainer>
        </InfoContainer>
      </Body>
    </ModalCustom>
  );
}
